import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetOpenWithFaireDesktopBreadcrumbOptions } from "@faire/retailer-visitor-shared/components/Header/HeaderOpenWithFaire/__internal__/useGetOpenWithFaireDesktopBreadcrumbOptions";
import { HeaderMobileHamburgerMenu } from "@faire/retailer-visitor-shared/components/Header/mobile/HeaderMobileHamburgerMenu";
import { HeaderLink } from "@faire/retailer-visitor-shared/components/Header/styled";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { Chevron } from "@faire/web--source/slate/icons/Chevron";
import { Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Breadcrumbs } from "@faire/web--source/ui/Breadcrumbs";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { route as openWithFaireRoute } from "@faire/web-api--source/routes/open-with-faire";
import { route as openWithFaireAcademyRoute } from "@faire/web-api--source/routes/open-with-faire/academy";
import * as React from "react";
import { useLocation } from "react-router-dom";
export var OpenWithFaireBreadcrumbs = function() {
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return /*#__PURE__*/ _jsx(Row, {
        align: "center",
        children: isDesktopAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "3x"
                }),
                /*#__PURE__*/ _jsx(OpenWithFaireBreadcrumbDesktop, {})
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(HeaderMobileHamburgerMenu, {}),
                /*#__PURE__*/ _jsx(OpenWithFaireBreadcrumbMobile, {})
            ]
        })
    });
};
var OpenWithFaireFaireLogo = /*#__PURE__*/ React.memo(function() {
    return /*#__PURE__*/ _jsx(HeaderLink, {
        to: home(),
        children: /*#__PURE__*/ _jsx(FaireLogo, {
            size: 104
        })
    });
});
var OpenWithFaireBreadcrumbDesktop = function() {
    var openWithFaireBreadcrumbOptions = useGetOpenWithFaireDesktopBreadcrumbOptions();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OpenWithFaireFaireLogo, {}),
            /*#__PURE__*/ _jsx(Breadcrumbs, {
                options: openWithFaireBreadcrumbOptions
            })
        ]
    });
};
var OpenWithFaireBreadcrumbMobile = function() {
    var pathname = useLocation().pathname;
    if (pathMatchesRoute(pathname, openWithFaireRoute)) {
        return /*#__PURE__*/ _jsx(OpenWithFaireFaireLogo, {});
    }
    if (pathMatchesRoute(pathname, openWithFaireAcademyRoute)) {
        return /*#__PURE__*/ _jsx(HeaderLink, {
            to: openWithFaireRoute,
            children: /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Chevron, {
                        direction: "left"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "sox/wR",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Open with Faire"
                                }
                            ]
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(HeaderLink, {
        to: openWithFaireAcademyRoute,
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Chevron, {
                    direction: "left"
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "dpQSIi",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Guides"
                            }
                        ]
                    })
                })
            ]
        })
    });
};
